<template>
  <div class="container" v-if="loaded">
    <div class="row">
      <div class="col-xs-12 col-lg-5">
        <div class="input-group mt-4 w-100 lightShadow">
          <input
            type="text"
            class="form-control border-0"
            placeholder="Search..."
            aria-label="Search"
            aria-describedby="button-addon2"
          />
          <div class="input-group-append">
            <button class="btn btn-primary" type="button" id="button-addon2">Search</button>
          </div>
        </div>

        <div class="input-group mb-4 mt-3 w-100 lightShadow">
          <v-date-picker
            :popover="{ placement: 'bottom', visibility: 'click' }"
            :input-props="{
              class: 'form-control',
              readonly: true,
              style: 'border-radius: 4px 0px 0px 4px'
            }"
            mode="range"
            v-model="dateRange"
            class="form-control form-control-fix"
          />
          <div class="input-group-append">
            <button
              id="sortBy"
              type="button"
              class="btn btn-light dropdown-toggle font-weight-bold"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >Sort</button>
            <div class="dropdown-menu lightShadow" aria-labelledby="sortBy" id="sortByDropdown">
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'number')"
              >IR Number</button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem sortByActive"
                v-on:click="sortIRS($event, 'startTime')"
              >Date</button>
              <div class="dropdown-divider"></div>
              <button
                class="dropdown-item sortByDropdownItem"
                v-on:click="sortIRS($event, 'level')"
              >Level</button>
            </div>
          </div>
        </div>

        <div class="list-group lightShadow listOverflow">
          <IRListItems @emitUpdateCurrentIR="updateCurrentIR" :currentIR="currentIR" />
        </div>
      </div>
      <div class="col mt-4">
        <div class="card w-100 m-0 lightShadow">
          <div class="card-header">
            <ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link disabled"
                  href="#"
                  tabindex="-1"
                  aria-disabled="true"
                >#{{ currentIR.number }}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >IR</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >Files</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="contact-tab"
                  data-toggle="tab"
                  href="#contact"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >History</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="complete-tab"
                  data-toggle="tab"
                  href="#complete"
                  role="tab"
                  aria-controls="complete"
                  aria-selected="false"
                >Complete IR</a>
              </li>
            </ul>
          </div>
          <div class="card-body contentOverflow">
            <IRDetails v-bind:ir="currentIR" />
          </div>
          <div class="card-footer text-muted d-flex justify-content-between align-items-center">
            <small>IR Created At: 07/22/19 9:31 AM</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IRListItems from "../components/IRListItems";
import IRDetails from "../components/IRDetails";
export default {
  name: "Search",
  components: {
    IRListItems,
    IRDetails
  },
  data: function() {
    return {
      currentIR: null,
      loaded: false,
      dateRange: {
        start: this.$moment().subtract(7, "days")._d,
        end: this.$moment()._d
      }
    };
  },
  methods: {
    loadFirstIR: function() {
      const irs = this.$store.getters.irs;
      if (irs.length >= 1) {
        this.currentIR = irs[0];
        this.loaded = true;
      }
    },
    updateCurrentIR: function(newIRIndex) {
      this.currentIR = this.$store.getters.irs[newIRIndex];
    },
    sortIRS: function(e, property) {
      let sorted = this.$store.getters.irs;
      this.$store.commit(
        "sortIRS",
        sorted.sort(function(a, b) {
          return a[property] - b[property];
        })
      );

      let items = Array.from(
        document.getElementsByClassName("sortByDropdownItem")
      );
      items.map(item => item.classList.remove("sortByActive"));

      e.target.classList.add("sortByActive");
    }
  },
  mounted() {
    this.loadFirstIR();
  }
};
</script>

<style scoped>
.btn-group button {
  border-left: 1px solid #dfdfdf;
}

#irDisplay {
  background: #fff;
}

.listOverflow {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.contentOverflow {
  max-height: calc(100vh - 257px);
  overflow: auto;
}

.form-control {
  color: #000;
}

.sortByActive {
  color: #6c757d;
}

.form-control-fix {
  padding: 0px;
}
</style>